import { NextAction, NextActionDetails } from '../@types';
import { HTTP_METHOD_GET, HTTP_METHOD_POST, NEXT_ACTION_TYPE_DONE, NEXT_ACTION_TYPE_REDIRECT } from '../constants';

function handleRedirect(details: NextActionDetails, resolve: () => void, reject: () => void) {
  if (!('url' in details)) {
    resolve();
    return;
  }

  if (!('method' in details) || String(details.method).toUpperCase() === HTTP_METHOD_GET) {
    window.location.replace(details.url);
    reject();
    return;
  }

  if (String(details.method).toUpperCase() === HTTP_METHOD_POST && details.postData) {
    const redirectForm = document.createElement('form');
    redirectForm.setAttribute('action', details.url);
    redirectForm.setAttribute('method', 'post');
    redirectForm.setAttribute('hidden', 'true');

    Object.keys(details.postData).forEach((el: any) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', el);
      input.setAttribute('value', details.postData![el]);
      redirectForm.appendChild(input);
    });

    document.body.appendChild(redirectForm);
    redirectForm.submit();
    reject();
    return;
  }

  resolve();
}

export async function nextActionHandler(nextAction: NextAction): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    if (nextAction?.type === NEXT_ACTION_TYPE_DONE && nextAction?.onSuccess) {
      nextAction.onSuccess().then(() => resolve());
      return;
    }

    if (nextAction?.type === NEXT_ACTION_TYPE_REDIRECT) {
      const nextActionDetails = nextAction.details || nextAction.redirect; // for backwards compatibility
      handleRedirect(nextActionDetails, resolve, reject);
      return;
    }

    resolve();
  });
}
